import { SigLabel } from '../components/atelier';

export interface PricingProps {
  onBook: () => void;
}

export function Pricing({ onBook }: PricingProps) {
  return (
    <section id="pricing" className="container section">
      <div className="block-head">
        <div>
          <SigLabel>Pricing</SigLabel>
          <h2>
            Credits, not seats. <em>Pay for parts, not chairs.</em>
          </h2>
        </div>
        <p className="lede">
          One credit per LLM call. First draft and re-prompts each cost
          one credit; slider tweaks are free because they&rsquo;re just
          value changes in the parametric model, no LLM involved. Annual
          plans get two months on the house.
        </p>
      </div>

      <div className="pricing">
        <div className="price-card">
          <div className="name">Sketch</div>
          <div className="num">
            <span className="currency">&#8377;</span>
            2,000
            <span className="per">/ month</span>
          </div>
          <div className="credits">200 credits / month</div>
          <ul>
            <li>Single-part drafting</li>
            <li>STEP and STL export</li>
            <li>3D preview in browser</li>
            <li>Email support</li>
          </ul>
          <button type="button" className="cta cta-ghost" onClick={onBook}>
            Start sketching
          </button>
        </div>

        <div className="price-card featured">
          <div className="name">
            Studio <span style={{ color: 'var(--accent)', fontFamily: 'var(--font-serif)', fontStyle: 'italic', letterSpacing: 0, textTransform: 'none', marginLeft: 6 }}>· popular</span>
          </div>
          <div className="num">
            <span className="currency">&#8377;</span>
            6,000
            <span className="per">/ month</span>
          </div>
          <div className="credits">1,000 credits / month</div>
          <ul>
            <li>Everything in Sketch</li>
            <li>Priority generation queue</li>
            <li>Assembly drafting (early access)</li>
            <li>Version history &amp; rollback</li>
            <li>STEP 203 + 214 export</li>
            <li>Slack / Discord support</li>
          </ul>
          <button type="button" className="cta cta-primary" onClick={onBook}>
            Book a demo
          </button>
        </div>

        <div className="price-card">
          <div className="name">Practice</div>
          <div
            className="num"
            style={{ fontSize: 36, lineHeight: 1.1 }}
          >
            <span style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic' }}>
              Talk to us
            </span>
          </div>
          <div className="credits">Custom credit pool</div>
          <ul>
            <li>Team seats &amp; SSO</li>
            <li>Custom drafter fine-tuning</li>
            <li>Dedicated cloud capacity</li>
            <li>SOC 2 docs &amp; DPA</li>
            <li>Named onboarding engineer</li>
          </ul>
          <button type="button" className="cta cta-ghost" onClick={onBook}>
            Schedule a call
          </button>
        </div>
      </div>

      <p
        className="muted"
        style={{
          marginTop: 28,
          fontSize: 12,
          fontFamily: 'var(--font-mono)',
          letterSpacing: '0.06em',
          textAlign: 'center',
        }}
      >
        Credits roll over for 60&nbsp;days · Cancel anytime · Annual saves
        ~16%
      </p>
    </section>
  );
}
